import {Component, inject, OnInit, input, signal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatDatepicker, MatDatepickerInput} from "@angular/material/datepicker"
import {MatInputModule} from "@angular/material/input"
import {ArStatisticsFilterInput, SceneStatisticsFilterInput} from "@generated"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {PictureArStatisticsGQL, PictureSceneStatisticsGQL} from "@platform/components/pictures/picture-statistics/picture-statistics.generated"
import {endOfDay} from "date-fns/endOfDay"
import {startOfDay} from "date-fns/startOfDay"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-picture-statistics",
    imports: [FormsModule, MatDatepickerInput, MatDatepicker, MatInputModule],
    templateUrl: "./picture-statistics.component.html",
    styleUrl: "./picture-statistics.component.scss",
})
export class PictureStatisticsComponent implements OnInit {
    readonly $fromDate = signal(startOfDay(new Date()))
    readonly $toDate = signal(endOfDay(new Date()))
    readonly $datePickerMaxValue = signal<Date>(new Date())

    readonly $templateId = input<string>(undefined, {alias: "templateId"})
    readonly $templateRevisionId = input<string>(undefined, {alias: "templateRevisionId"})

    readonly arStatisticsGql = inject(PictureArStatisticsGQL)
    readonly sceneStatisticsGql = inject(PictureSceneStatisticsGQL)

    readonly $sceneStatisticsItemsCount = signal(0)
    readonly $arStatisticsItemsCount = signal(0)

    ngOnInit() {
        void this.updateStatistics()
    }

    async updateStatistics() {
        this.$fromDate.set(startOfDay(new Date()))
        this.$toDate.set(endOfDay(new Date()))
        const templateRevisionId = this.$templateRevisionId()
        if (templateRevisionId) {
            const filter: ArStatisticsFilterInput = {
                templateRevisionId: {equals: templateRevisionId},
                created: {gte: this.$fromDate().toJSON(), lte: this.$toDate().toJSON()},
            }
            const {arStatisticsItemsCount} = await fetchThrowingErrors(this.arStatisticsGql)({filter})
            this.$arStatisticsItemsCount.set(arStatisticsItemsCount)
        }
        const templateId = this.$templateId()
        if (templateId) {
            const filter: SceneStatisticsFilterInput = {
                templateId: {equals: templateId},
                created: {gte: this.$fromDate().toJSON(), lte: this.$toDate().toJSON()},
            }
            const {sceneStatisticsItemsCount} = await fetchThrowingErrors(this.sceneStatisticsGql)({filter})
            this.$sceneStatisticsItemsCount.set(sceneStatisticsItemsCount)
        }
    }
}
